// extracted by mini-css-extract-plugin
module.exports = {"container":"studentPortal_container__1LldS","spinner":"studentPortal_spinner__257ns"};